import { useRouter } from "next/router";
import { CustomerEditor } from "../../components/customer/customerEditor";
import PosLayout from "../../components/layouts/posLayout.comp";
import { EditingMode } from "../../components/reuseables/form.comp";
import { useTranslation } from "../../core/translation.core";

export default function AddCustomerPage() {
  return (
    <PosLayout title="Customer Page" noPadding>
      <AddNewCustomer />
    </PosLayout>
  );
}

function AddNewCustomer() {
  const router = useRouter();
  const { t, msg } = useTranslation();

  function handleCloseEditor() {
    router.push("/customers");
  }

  return (
    <section id="new-customer-section" className="flex justify-center">
      <div className="shadow-md space-y-8 px-4 py-6 dark:text-white bg-pos-dark md:rounded-2xl w-full md:w-[500px]">
        <h1 className="text-2xl font-medium">{t(msg.pos.addNewCustomer)}</h1>

        <CustomerEditor mode={EditingMode.create} handleCloseEditor={handleCloseEditor} />
      </div>
    </section>
  );
}
